import { ENTORNO } from "../utils/constantes";
import { getToken } from "../utils/variablesLocales";

export class apiGeolocalizacion {
  baseApi = ENTORNO.BASE_API;

  async LatLonToDireccionPostal(Lat, Lon) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.GEOLOCALIZACION_LatLonToDireccionPostal}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Lat: Lat,
          Lon: Lon,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();
      if (respuesta.status !== 200) throw respuestaJson;
      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async LatLonToDireccionPostalGoogle(Lat, Lon) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.GEOLOCALIZACION_LatLonToDireccionPostalGoogle}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Lat: Lat,
          Lon: Lon,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();
      if (respuesta.status !== 200) throw respuestaJson;
      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async autocomplete(DireccionABuscar, localidad, provincia, pais, Numeracion) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.GEOLOCALIZACION_autocomplete}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          DireccionABuscar: DireccionABuscar,
          localidad: localidad,
          provincia: provincia,
          pais: pais,
          Numeracion: Numeracion,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();
      if (respuesta.status !== 200) throw respuestaJson;
      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }
}
